import { SET_LOGGEDIN, SET_TOKEN, SET_USER_DETAILS, SET_MENU_ITEMS, SET_SELLERCREATION, SET_ACCOUNTTYPE, SET_BUYNOWPRODUCTS, SET_ACCOUNT_DETAILS, SET_TOCCUPATION, SET_EDUCATIONLIST, SET_FULL_EDUCATIONLIST, SET_ZODIACSIGNS, SET_FLAWS, SET_STATUS, SET_OCCUPATION, SET_ALLSTARS, SET_FULL_OCCUPATIONS, SET_TEDUCATIONS, SET_TFLAWS, SET_TSTATUS, SET_DHISA, SET_TDHISA } from "./constants";

export const setLoggedIn = (value) => {
    if (!value) {
        localStorage.removeItem('token')
    }
    return {
        type: SET_LOGGEDIN,
        payload: value
    }
}

export const setToken = value => ({
    type: SET_TOKEN,
    payload: value
})

export const setUserDetails = value => ({
    type: SET_USER_DETAILS,
    payload: value
})

export const setMenuItems = value => ({
    type: SET_MENU_ITEMS,
    payload: value
})

export const setSellerCreation = value => ({
    type: SET_SELLERCREATION,
    payload: value
})

export const setAccountType = value => ({
    type: SET_ACCOUNTTYPE,
    payload: value
})

export const setBuyNowProducts = value => ({
    type: SET_BUYNOWPRODUCTS,
    payload: value
})

export const setAccountDetails = value => ({
    type: SET_ACCOUNT_DETAILS,
    payload: value
})

export const setEducationList = value => ({
    type: SET_EDUCATIONLIST,
    payload: value
})

export const setFullEducations = value => ({
    type: SET_FULL_EDUCATIONLIST,
    payload: value
})

export const setZodiacSigns = value => ({
    type: SET_ZODIACSIGNS,
    payload: value
})

export const setFlaws = value => ({
    type: SET_FLAWS,
    payload: value
})

export const setStatus = value => ({
    type: SET_STATUS,
    payload: value
})

export const setOccupation = value => ({
    type: SET_OCCUPATION,
    payload: value
})

export const setAllStars = value => ({
    type: SET_ALLSTARS,
    payload: value
})

export const setFullOccupation = value => ({
    type: SET_FULL_OCCUPATIONS,
    payload: value
})

export const setTEducation = value => ({
    type: SET_TEDUCATIONS,
    payload: value
})

export const setTFlaws = value => ({
    type: SET_TFLAWS,
    payload: value
})

export const setTStatus = value => ({
    type: SET_TSTATUS,
    payload: value
})

export const setTOccupation = value => ({
    type: SET_TOCCUPATION,
    payload: value
})

export const setDhisa = value => ({
    type: SET_DHISA,
    payload: value
})

export const setTDhisa = value => ({
    type: SET_TDHISA,
    payload: value
})